import { DailyReportController } from './dailyReport.controller';

const angular = require('angular');

export default angular.module('directives.dailyReportComponent', [])
    .component('dailyReport', {
        template: require('./index.pug'),
        controller: DailyReportController,
        controllerAs: 'report',
        bindings: {
            mode: '=',
            report: '=',
            currentShop: '=?shop',
            onRefresh: '&'
        },
        bindToController: true,
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/dailyReport/index.ts